import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../errors/api-error-handler";
import { AccordionInitialStateType, AccordionTypes } from "../../models/accordion-model";
import AccordionService from "../../services/accordion.service";

const initialState: AccordionInitialStateType = {
  AccordionData: [],
  AccordionScheduleData: [],
  AccordionProfileData: [],
  AccordionLoading: true,
  AccordionError: undefined,
};

export const retrieveAccordionSchedule = createAsyncThunk(
  "Accordion/retrieve",
  async (path: string) => {
    const response = await AccordionService.getAccordionService(path)
    return [response.data];
  }
);

const AccordionScheduleSlice = createSlice({
  name: "board-of-Editors",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveAccordionSchedule.pending, (state) => {
        state.AccordionLoading = true;
      })
      .addCase(retrieveAccordionSchedule.fulfilled, (state, action) => {
        if (action.payload) {
          state.AccordionLoading = false;
          state.AccordionScheduleData = action.payload as AccordionTypes[];
        }
      })
      .addCase(retrieveAccordionSchedule.rejected, (state, { payload }) => {
        state.AccordionLoading = false;
        state.AccordionError = apiErrorHandler(Number(payload));
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default AccordionScheduleSlice.reducer;
